import React from "react";
import "./templateThree.css";
import { Box } from "@chakra-ui/react";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { convertAmountToWords } from "components/allForm/PaymentMode/helper";
import TermsAndConditions from "./commonComponent/termsAndConditions";
import { Col, Row } from "react-bootstrap";
import BankDetails from "./commonComponent/bankDetails";
import { calculateItemGstAmount } from "../uttils/calculateItemGstAmount";
import BankDetailsWithProvidedData from "./commonComponent/bankDetailsWithDataProvided";

const ShowAddress = ({address}) => {
  if (!address) return {};
  const city = address.cityName;
  const country = address.countryName;
  const state = address.stateName;
  return (
    <>
      <p>Attn: {address?.atn}</p>
      <p>{address?.s1}</p>
      <p>{address?.s2}</p>
      <p>
        {city} {address?.pin}
      </p>
      <p>
        {state} {country}
      </p>
    </>
  )
}

const InvoiceTemplateThree = ({
  title,
  idNo,
  invoice,
  invoiceDate,
  invoiceTerms,
  invoiceCurrency,
  invSub,
  itemList,
  currency,
  clientId,
  clientGst,
  gst,
  totalAmount,
  freightCharge,
  adjustment,
  customerNotes,
  totalPaymentAmount,
  dueDate,
  orgAddress,
  clientAddress,
  clientShippingAddress,
  clientDetail,
  logoUrl,
  organizationData,
  selectedBankDetails,
  isProforma
}) => {
  return (
    <div id="Template3" className="template-three">
      <div className="invoice-template">
        <table className="info-table">
          <tbody>
            <tr>
              <td colSpan={4}>
                <div className="header">
                  <Box display="flex">
                    <div className="logo">
                      <img src={logoUrl} alt="Logo" />
                    </div>
                    <div className="company-info">
                      <p className="title fw-600">{organizationData?.name}</p>
                      <p>{organizationData?.add?.s1}</p>
                      <p>{organizationData?.add?.s2}</p>
                      <p>{orgAddress?.city}</p>
                      <p>Pin Code: {organizationData?.add?.pin}</p>
                      <p>
                        {orgAddress?.state} , {orgAddress?.country}
                      </p>
                      <p>Phone: {organizationData?.add?.ph}</p>
                      <p>Pan No: {organizationData?.pnNo}</p>
                      <p>Gst In: {organizationData?.gstNo}</p>

                      <p className="web-link">
                        <a href={organizationData?.web}>
                          {organizationData?.web}
                        </a>
                      </p>
                    </div>
                  </Box>
                  <div className="invoice-title">
                    <p>{title}</p>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="2" width="50%">
                <Row>
                  <Col>
                    <p>INVOICE#</p>
                    <p>DATE</p>
                    <p>TERMS</p>
                    <p>DUE DATE</p>
                  </Col>
                  <Col>
                    <p>: {invoice?.value}</p>
                    <p>: {invoiceDate?.value}</p>
                    <p>: {invoiceTerms?.value}</p>
                    <p>: {dueDate?.value}</p>
                  </Col>
                </Row>
              </td>
              <td colSpan="2">
                <Row>
                  <Col>
                    <p>SUBJECT</p>
                    <p>CURRENCY</p>
                  </Col>
                  <Col>
                    <p>: {invSub?.value}</p>
                    <p>: {invoiceCurrency?.value}</p>
                  </Col>
                </Row>
              </td>
            </tr>
            <tr className="bg">
              <td colSpan={2}>
                <p className="fw-600">Bill To</p>
              </td>
              <td>
                <p className="fw-600">Ship To</p>
              </td>
            </tr>
            <tr>
              <td colSpan="2">
                <p className="fw-600">{clientDetail?.clName}</p>
                <ShowAddress address={clientAddress} />
                <p>GSTIN {clientGst || "NA"}</p>
              </td>
              <td colSpan="2">
                <p className="fw-600">{clientDetail?.clName}</p>
                <ShowAddress address={clientShippingAddress} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <table className="package-table">
        <thead>
          <tr className="bg">
            <th width="40%">Item & Description</th>
            <th className="text-end">Qty</th>
            <th className="text-end">Rate</th>
            <th className="text-center">TAX</th>
            {currency?.code === 'INR' &&<th className="text-center">{gst?.type === 'IGST' ? "IGST" :"CGST & SGST"}</th>}
            <th className="text-end">Amount</th>
          </tr>
        </thead>
        <tbody>
          {itemList &&
            itemList?.length &&
            itemList.map((item) => {
              const calTax = formatAmountIndianRupees(calculateItemGstAmount(item) || 0);

              return (
                <tr>
                  <td>
                    <p className="fw-600">{item?.slItm?.name}</p>
                    <p style={{ lineHeight: "1.3" }}>{item?.slItm?.dc}</p>
                    <p>HSN/SAC - {item?.slItm?.hCd || item?.slItm?.sCd}</p>
                  </td>
                  <td className="text-end">{item?.qty}</td>
                  <td className="text-end">
                    {formatAmountIndianRupees(item?.prc)}
                  </td>
                  <td className="text-center">{item?.tax?.label || "-"}</td>
                  {currency?.code === 'INR' &&<td className="text-center">{calTax}</td>}
                  <td className="text-end">
                    {formatAmountIndianRupees(item?.amt)}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>

      <Box
        className="summary-box"
        m={0}
        display="flex"
        justifyContent="space-between"
      >
        <div className="p-2">
          <p>Total In Words</p>
          <p className="fw-600">
            {currency?.code} {convertAmountToWords(totalPaymentAmount || 0)}
          </p>
          {customerNotes ? (
            <>
              <p>Notes</p>
              <p>{customerNotes}</p>
            </>
          ) : (
            ""
          )}
        </div>
        <table className="summary-table">
          <tbody>
            <tr>
              <td className="heading">Sub Total</td>
              <td className="text-end">
                {currency?.symbol || "₹"}{" "}
                {formatAmountIndianRupees(totalAmount || 0)}
              </td>
            </tr>
            {currency.code === "INR" ? (
              <>
                <tr>
                  <td className="heading">IGST</td>
                  <td className="text-end">
                    {currency?.symbol || "₹"}{" "}
                    {formatAmountIndianRupees(gst?.amount?.i || 0)}
                  </td>
                </tr>
                <tr>
                  <td className="heading">SGST</td>
                  <td className="text-end">
                    {currency?.symbol || "₹"}{" "}
                    {formatAmountIndianRupees(gst?.amount?.s || 0)}
                  </td>
                </tr>
                <tr>
                  <td className="heading">CGST</td>
                  <td className="text-end">
                    {currency?.symbol || "₹"}{" "}
                    {formatAmountIndianRupees(gst?.amount?.c || 0)}
                  </td>
                </tr>
              </>
            ) : (
              ""
            )}
            {freightCharge ? (
              <tr>
                <td className="heading">Freight Charges</td>
                <td className="text-end">
                  {currency?.symbol || "₹"}{" "}
                  {formatAmountIndianRupees(freightCharge || 0)}s
                </td>
              </tr>
            ) : (
              ""
            )}
            {adjustment?.value ? (
              <tr>
                <td className="heading">{adjustment?.label}</td>
                <td className="text-end">
                  {currency?.symbol || "₹"}{" "}
                  {formatAmountIndianRupees(adjustment?.value || 0)}s
                </td>
              </tr>
            ) : (
              ""
            )}

            <tr>
              <td className="heading">
                <strong>Total</strong>
              </td>
              <td className="text-end fw-600">
                {currency?.symbol || "₹"}{" "}
                {formatAmountIndianRupees(totalPaymentAmount)}
              </td>
            </tr>
          </tbody>
        </table>
      </Box>
      <Box>
        <table className="footer-table">
          <tbody>
            <tr>
              <td colSpan={3} className=""></td>
            </tr>
            <tr>
              <td>
                <TermsAndConditions isProforma={isProforma} />
              </td>
            </tr>
            {organizationData?.isBnk && (
              <tr>
                <td>
                  {organizationData?.isBnk && <BankDetailsWithProvidedData bankDetails={selectedBankDetails} />}
                </td>
              </tr>
            )}
            <tr>
              <td colSpan="4">
                <p className="contact">
                  {isProforma
                    ? organizationData?.pfFtxt
                    : organizationData?.sFtxt}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </Box>
    </div>
  );
};

export default InvoiceTemplateThree;
